import { render } from "./index.vue?vue&type=template&id=1081430e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__